import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useForm, Controller } from "react-hook-form";
import api from "../../api/api";

const EditEmployee = ({ client, onSave, onClose }) => {
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: client.name || "",
      email: client.email || "",
      // password: "",
      // confirmPassword: "",
      docNumber: client.docNumber || "",
      phone: client.phone || "",
    },
  });

  // Update form values when client prop changes
  useEffect(() => {
    if (client) {
      setValue("name", client.name || "");
      setValue("email", client.email || "");
      // setValue("phone", client.phone || "");
      setValue("docNumber", client.docNumber || "");
    }
  }, [client, setValue]);

  const onSubmit = async (data) => {
    try {
      await onSave(client.id, data);
      onClose();
    } catch (error) {
      console.error("Failed to update client", error);
    }
  };

  return (
    <Box sx={{ padding: 5 }}>
      <Typography variant="h5" marginBottom={3}>
        Editar Colaborador
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          {/* Campos Básicos */}
          <Grid item xs={12} sm={6}>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField {...field} label="Nome" fullWidth />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextField {...field} label="Email" fullWidth />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <TextField {...field} label="Telefone" fullWidth />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controller
              name="docNumber"
              control={control}
              render={({ field }) => (
                <TextField {...field} label="Número do Documento" fullWidth />
              )}
            />
          </Grid>

          {/* <Grid item xs={12} fullWidth marginTop={3}>
            <Typography variant="subtitle1">Atualização de Senha</Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Controller
              name="password"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="password"
                  label="Nova Senha"
                  fullWidth
                  error={!!errors.password}
                  helperText={errors.password ? errors.password.message : ""}
                />
              )}
              rules={{
                minLength: {
                  value: 6,
                  message: "A senha deve ter pelo menos 6 caracteres",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Controller
              name="confirmPassword"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="password"
                  label="Confirmar Senha"
                  fullWidth
                  error={!!errors.confirmPassword}
                  helperText={
                    errors.confirmPassword ? errors.confirmPassword.message : ""
                  }
                />
              )}
              rules={{
                validate: (value) =>
                  value === getValues("password") || "As senhas não coincidem",
              }}
            />
          </Grid> */}
        </Grid>
        <div style={{ marginTop: 20 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ marginRight: 10 }}
          >
            Cancelar
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Salvar
          </Button>
        </div>
      </form>
    </Box>
  );
};

export default EditEmployee;
